export const getImageFileName = (path: string) => path.split('/')[2]
